<template>
    <div class="flex flex-col gap-1" :class="copyClasses" @click="handleCopyValue(props.copyValue)">
        <div class="flex flex-row items-center gap-1 text-xs text-sub [overflow-wrap:anywhere] group-hover:text-default">
            {{ label }} <Icon type="copy" :filled="true" v-if="props.copyValue" class="w-2.5" />
        </div>
        <div class="flex flex-row gap-2 text-sm font-medium [overflow-wrap:anywhere]">
            <slot>{{ props.value }}</slot>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { Icon } from '@tapp.online/ui'
    import { useCopy } from '@/composables'
    const { copyValue: handleCopyValue } = useCopy()

    const props = withDefaults(
        defineProps<{
            label: string
            value?: string | number
            copyValue?: string
        }>(),
        {}
    )

    const copyClasses = computed(() => {
        return props.copyValue ? 'hover:cursor-pointer hover:text-default group' : ''
    })
</script>
